import { render, staticRenderFns } from "./CdkLayout.vue?vue&type=template&id=dbfa589e&scoped=true&"
import script from "./CdkLayout.vue?vue&type=script&lang=js&"
export * from "./CdkLayout.vue?vue&type=script&lang=js&"
import style0 from "./CdkLayout.vue?vue&type=style&index=0&id=dbfa589e&scoped=true&lang=css&"
import style1 from "./CdkLayout.vue?vue&type=style&index=1&id=dbfa589e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfa589e",
  null
  
)

export default component.exports